/**
 * @file components/FollowUs/component.js
 * @copyright 2016 CBC/Radio-Canada. All rights reserved.
 * @author Mike Saxton [michael.saxton@cbc.ca]
 */

// Library imports
import { Heading } from "../Heading/component";

// Component imports
import Image from "../ImageWrapper/component";
import LinkWrap from "../LinkWrap/component";
import { FOLLOWUS_LIST, FOLLOWUSLOCATIONS_LIST } from "./constants";

/**
 * The FollowUs component.
 *
 * This component displays icons that link to social media sites
 *
 * @param {Object} props The component props
 * @returns {React.Component} Returns the FollowUs component
 */
export function FollowUs(props) {
    // Get the config list of follow us link for the current page
    const currentPageFollowUsData =
        FOLLOWUS_LIST[props.path] !== undefined
            ? FOLLOWUS_LIST[props.path]
            : null;
    let followUsTitle = "";
    let followUsListItems = [];
    let followUsShortTitle = "";

    if (currentPageFollowUsData) {
        followUsTitle = currentPageFollowUsData.title;
        followUsShortTitle = followUsTitle.replace("Follow ", "");
        followUsListItems = currentPageFollowUsData.links.map((item, index) => {
            let { userAction, displayName } =
                FOLLOWUSLOCATIONS_LIST[item.socialNetwork];
            let followUsDescription = `${userAction} ${followUsShortTitle} on ${displayName}`;

            return (
                <li key={`${index}-followUs`}>
                    <LinkWrap url={item.url} external={true}>
                        <Image
                            url={`${
                                FOLLOWUSLOCATIONS_LIST[item.socialNetwork]
                                    .imageUrl
                            }`}
                            type="followUs-image"
                        />
                        <span className="a11y" key={`${index}-followUs-action`}>
                            {followUsDescription}
                        </span>
                    </LinkWrap>
                </li>
            );
        });
    }

    return getFollowUsMarkup(followUsTitle, followUsListItems);
}

function getFollowUsMarkup(followUsTitle, followUsListItems) {
    if (!followUsListItems || !followUsListItems.length) {
        return null;
    }

    return (
        <div className="followUs">
            <Heading
                className="followUsHeadline"
                text={followUsTitle}
                level={"h2"}
                levelClassName={"h3"}
            />
            <ul>{followUsListItems}</ul>
        </div>
    );
}

export default FollowUs;
